import { render } from "./PageSoruArsiv.vue?vue&type=template&id=43c2651a&scoped=true"
import script from "./PageSoruArsiv.vue?vue&type=script&lang=js"
export * from "./PageSoruArsiv.vue?vue&type=script&lang=js"

import "./PageSoruArsiv.vue?vue&type=style&index=0&id=43c2651a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43c2651a"

export default script